'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/helpers/bind.js
// module id = JP+z
// module chunks = 142